(function () {
    angular.module('components.carousel')
        .component('carouselSet', {
            bindings: {
                small: '<',
                medium: '<?',
                large: '<?',
                items: '<',
                animation: '&?',
                animationDuration: '<?',
                interval: '<?',
                maxHeight: '<?'
            },
            controller: carouselSetController
        });

    carouselSetController.$inject = ['$scope', '$element', '$compile', '$timeout', '$window', 'helper'];
    function carouselSetController($scope, $element, $compile, $timeout, $window, helper) {
        var ctrl = this;
        var content = angular.copy($element.contents());
        ctrl.$onInit = function () {
            ctrl.$currentIndex = 0;
            if (!ctrl.medium) {
                ctrl.medium = ctrl.small;
            }
            if (!ctrl.large) {
                ctrl.large = ctrl.medium || ctrl.small;
            }
            if (!ctrl.interval) {
                ctrl.interval = 6000;
            }
            if (!ctrl.animationDuration) {
                ctrl.animationDuration = 1;
            }
            if (!ctrl.animation) {
                ctrl.animation = function (callback) {
                    tl = new TimelineLite();
                    var duration = ctrl.animationDuration / 2;
                    tl.staggerFromTo($element.find('> .current > li'), duration, {
                        transform: 'rotateX(0)'
                    }, {
                        transform: 'rotateX(90deg)'
                    }, .1, 0, function () {
                        $timeout(function () {
                            ctrl.$currentIndex = (ctrl.$currentIndex + ctrl.$setSize) % ctrl.items.length;
                            ctrl.$$buildSets();
                            tl.staggerFromTo($element.find('> .current > li'), duration, {
                                transform: 'rotateX(270deg)'
                            }, {
                                transform: 'rotateX(360deg)'
                            }, .1, '+=0', callback);
                        });
                    });
                }
            }
            ctrl.$mediaQueries = helper.getMediaQueries();
            angular.element($window).on('resize.carouselSet', ctrl.$$setSizing);
            ctrl.$$setSizing();
            ctrl.$$buildSets(ctrl.items);
        }
        ctrl.$onChanges = function (changes) {
            if (changes.items.currentValue) {
                ctrl.$$buildSets(changes.items.currentValue);
                $timeout.cancel(ctrl.$timer);
                if (ctrl.items.length > ctrl.$setSize) {
                    ctrl.$timer = $timeout(ctrl.$$switchSets, ctrl.interval);
                }
            }
            if (changes.maxHeight.currentValue) {
                ctrl.heightSetting = {
                    height: ctrl.maxHeight
                };
            }
        }

        ctrl.$postLink = function () {
            ctrl.$template = angular.element('<ul class="set current" ng-style="$ctrl.heightSetting"><li ng-repeat="item in $ctrl.currentSet track by $index"></li></ul>');
            ctrl.$template.find('li').append(content);
            $element.html(ctrl.$template);
            $compile($element.contents())($scope);
            if (ctrl.items && ctrl.items.length > ctrl.$setSize) {
                $timeout.cancel(ctrl.$timer);
                ctrl.$timer = $timeout(ctrl.$$switchSets, ctrl.interval)
            }
        }

        ctrl.$$setSizing = function () {
            var prevSize = ctrl.$setSize;
            var keys = Object.keys(ctrl.$mediaQueries);
            for (var i = 0; i < keys.length; i++) {
                var key = keys[i];
                if (key.indexOf("down") === -1 && key.indexOf("up") === -1 && key.indexOf("only") === -1) {
                    if (ctrl.$mediaQueries[key].matches) {
                        if (ctrl[key]) {
                            ctrl.$setSize = ctrl[key];
                        }
                    }
                    else {
                        break;
                    }
                }
            }
            if (prevSize !== ctrl.$setSize) {
                if (ctrl.items && ctrl.items.length > ctrl.$setSize) {
                    $timeout.cancel(ctrl.$timer);
                    ctrl.$timer = $timeout(ctrl.$$switchSets, ctrl.interval);
                }
            }
        }

        ctrl.$$switchSets = function () {
            $timeout(function () {
                ctrl.animation(function () {
                    $timeout.cancel(ctrl.$timer);
                    if (ctrl.items.length > ctrl.$setSize) {
                        ctrl.$timer = $timeout(ctrl.$$switchSets, ctrl.interval);
                    }
                });
            });
        }

        ctrl.$$buildSets = function() {
            if (ctrl.items !== undefined) {
                if (ctrl.items.length <= ctrl.$setSize) {
                    ctrl.currentSet = ctrl.items;
                }
                else {
                    var end = (ctrl.$currentIndex + ctrl.$setSize) % ctrl.items.length;
                    var endShort = end < ctrl.$currentIndex;
                    ctrl.currentSet = ctrl.items.slice(ctrl.$currentIndex, endShort ? ctrl.items.length : end);
                    if (endShort) {
                        ctrl.currentSet = ctrl.currentSet.concat(ctrl.items.slice(0, ctrl.$setSize - ctrl.currentSet.length));
                    }
                }
            }
            else {
                ctrl.currentSet = [];
                ctrl.nextSet = [];
            }
        }
    }
})();